import React, { useState } from "react";
import PortfolioGrid from "./portfolio/PortfolioGrid";
import WeekendModeContent from "./common/WeekendModeContent";
import ProfilePortrait from "./common/ProfilePortrait";
import WeekendPortrait from "./common/WeekendPortrait";
import SocialIcon from "./common/SocialIcon";
import MenuSocialIcons from "./common/MenuSocialIcons";
import Footer from "./Footer";
import SiteLogo from "./common/SiteLogo";
import { Link } from "react-router-dom";

const profileImage = `${process.env.PUBLIC_URL}/haseeb.png`;

const Portfolio = () => {
  const [isBurgerClicked, setIsBurgerClicked] = useState(false);

  const handleBurgerClick = () => {
    setIsBurgerClicked((prevClicked) => !prevClicked);
  };
  return (
    <>
      {/* <!--Salva page content start here --> */}
      <div className="salva-page-wrap portfolio-page-wrap">
        {/* <!--Salva portfolio content start here--> */}
        <section
          className="salva-fixed-content salva-dark-section"
          id="portfolio"
        >
          <div className="container-fluid">
            <div className="row home-content-row">
              {/* <!--Left side salva fixed image start here--> */}
              <div className="col-12 col-md-5 col-lg-4 col-xxl-5 salva-left-fixed-image p-0">
                <h1 className="d-none">this is a image of salva fixed</h1>
                <ProfilePortrait className="salva-home-image" />
                <WeekendPortrait className="salva-weekend-image" />
              </div>
              {/* <!--Left side salva fixed image end here --> */}
              {/* <!--right side salva content start here--> */}
              <div className="col-12 col-md-12 col-lg-8 col-xxl-7 salva-home-content dark-salv-portfolio-content  p-0">
                <div
                  className={`salva-about-wrap ${
                    isBurgerClicked ? "border-none" : ""
                  }`}
                >
                  {/* <!--header content start here --> */}
                  <header className="salva-header salv-home-header salv-dark-header">
                    <div className="container-fluid p-0">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                          <a className="salva-logo" href="/">
                            <SiteLogo />
                          </a>
                        </div>
                        <div className="col-6 col-sm-6 col-md-8 col-lg-8">
                          <nav className="navbar salva-header-nav dark-salv-header">
                            <div className="d-flex">
                              <input
                                type="checkbox"
                                id="navcheck"
                                className="navcheck"
                                role="button"
                                title="menu"
                                aria-pressed="true"
                              />
                              <label
                                htmlFor="navcheck"
                                aria-hidden="true"
                                title="menu"
                              >
                                <span
                                  className={`salv-burger dark-salv-burger ${
                                    isBurgerClicked ? "click" : ""
                                  }`}
                                  onClick={handleBurgerClick}
                                >
                                  <span className="bar dark-bar">
                                    <span className="visuallyhidden">Menu</span>
                                  </span>
                                </span>
                              </label>
                              {/* <!--desktop screen menu design --> */}
                              <ul
                                id="menu"
                                className="sal-menu-list dark-sal-menu-list"
                              >
                                <li className="salv-menu-item">
                                  <Link
                                    to="/"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    Home
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/about"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    About
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/portfolio"
                                    target="_self"
                                    className="w-text salv-menu-link dark-menu-link active"
                                  >
                                    Portfolio
                                  </Link>
                                </li>
                                <li className="salv-menu-item">
                                  <Link
                                    to="/contact"
                                    target="_self"
                                    className="salv-menu-link dark-color"
                                  >
                                    Contact
                                  </Link>
                                </li>
                              </ul>
                              {/* <!--tablet screen menu design --> */}
                              <div className="salv-menu-design-two">
                                <div className="menu-design-wrap">
                                  <div className="salv-menu-profile">
                                    <img
                                      src={profileImage}
                                      alt="Haseeb Sajjad profile"
                                    />
                                  </div>
                                  <div className="sakv-new-menu-social">
                                    <MenuSocialIcons />
                                  </div>
                                  <div className="salv-menu-list">
                                    <ul className="salv-sec-menu-item">
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/"
                                          className="slav-tb-menu-name"
                                          target="_self"
                                        >
                                          home
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/about"
                                          target="_self"
                                          className="slav-tb-menu-name"
                                        >
                                          about
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/portfolio"
                                          target="_self"
                                          className="slav-tb-menu-name active"
                                        >
                                          portfolio
                                        </Link>
                                      </li>
                                      <li className="salv-sec-menu-link">
                                        <Link
                                          to="/contact"
                                          target="_self"
                                          className="slav-tb-menu-name"
                                        >
                                          contact
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="salv-mob-copyright">
                                    <p className="salv-copyright-content mb-0 sm-font inter-font-400 b-text">
                                      Copyright © 2023 Salva ❤{" "}
                                      <Link
                                        to="https://1.envato.market/website-portfolio"
                                        className="b-text"
                                        target="_blank"
                                      >
                                        the_krishna
                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </header>

                  <div>
                    <div className="salva-about-content salva-portfolio-content">
                      <div className="salv-inrto-content dark-about-content">
                        <div className="portfolio-title">
                          <h2
                            className="salv-about-title salv-home-title md-font w-text inter-font-900 mb-0"
                            data-aos="flip-left"
                            data-aos-easing="ease-out-cubic"
                            data-aos-duration="3000"
                          >
                            Portfolio
                          </h2>
                        </div>
                        <div className="sec-text">
                          <p
                            className="salv-about-desc mb-0 dark-sec-color inter-font-400"
                            data-aos="fade-in"
                            data-aos-duration="3000"
                          >
                            Here are websites and software systems I have worked
                            on, including education platforms, business tools,
                            LMS, HRMS, chat systems, and custom web solutions.
                          </p>
                          <p
                            className="salv-about-desc mb-0 dark-sec-color inter-font-400 portfolio-access-note"
                            data-aos="fade-in"
                            data-aos-duration="3000"
                          >
                            Direct links to private software are not shared on
                            this portfolio. For software details, please contact
                            the admin.
                          </p>
                        </div>
                        <div className="salv-home-get-touch dark-home-get-touch salv-portfol-get-btn">
                          <Link
                            to="/contact"
                            className="salv-get-page-btn"
                          >
                            <span className="salv-get-text">
                              if you are interested, get in touch
                            </span>
                          </Link>
                        </div>
                      </div>
                      <PortfolioGrid />
                    </div>
                  </div>
                  {/* <!--weekend-mode start here--> */}
                  <WeekendModeContent />

                  {/* <!--social icon start here --> */}
                  <SocialIcon />

                  {/* <!--footer content start here --> */}
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--Salva portfolio content end here--> */}
      </div>
    </>
  );
};
export default Portfolio;
